export default __webpack_public_path__ + "static/b3-f695dc93f51eac4328cfbff2e66c270a.png";